'use strict';

angular.module('atex.aceui.service').factory('FileService',
['$q', '$rootScope', 'AuthenticationService', 'ApplicationConfigurationService',

  function($q, $rootScope, AuthenticationService, ApplicationConfigurationService) {
    var serviceHandler = undefined;

    var handler = function() {
      if (serviceHandler !== undefined) {
        return $q.when(serviceHandler);
      }

      return ApplicationConfigurationService.getServiceConfigurationFor('FileService').then(function(configuration) {
        var serviceUrl = atex.aceui.ServiceUtils.calculateServiceUrl(configuration, 'file');

        var serviceSettings = { customQ: atex.aceui.AngularUtils.applyingQ($q, $rootScope) };
        serviceHandler = atex.aceui.service.FileService(serviceUrl, serviceSettings);

        return serviceHandler;
      });
    };

    return {
      /**
       * Retrieves an ACE content file from the file service and returns the contents as a Blob.
       * Wraps the request with an authentication guard.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.fileUri - the file service URI of the file to retrieve
       * @param {function} transferInfo.onProgress - a callback function that, if specified, will receive file on-progress calls
       * @param {function} transferInfo.abort - a transfer abort function added to the input object by this method
       * @param {string} transferInfo.authToken - the authorization token to use for the file request
       *
       * @see atex.aceui.service.FileService
       * @see AuthenticationService
       *
       * @returns {Promise.<Blob, atex.aceui.error.Error>}
       */
      getFile: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return AuthenticationService.verifyLoggedIn().then(function() {
            return handler().then(function(serviceHandler) {
              return serviceHandler.getFile(_.extend(transferInfo, { authToken: currentUser.token }));
            });
          });
        });
      },

      /**
       * Uploads a File object to the ACE file service in the temporary file space.
       * Wraps the request with an authentication guard.
       *
       * @param {Object} transferInfo - a transfer info object containing request details
       * @param {string} transferInfo.fileUri - the file service URI to use when storing the uploading file
       * @param {string} transferInfo.fle - the File object to upload
       * @param {function} transferInfo.onProgress - a callback function that, if specified, will receive file on-progress calls
       * @param {function} transferInfo.abort - a transfer abort function added to the input object by this method
       * @param {string} transferInfo.authToken - the authorization token to use for the file request
       *
       * @typedef {Object} FileInfo - the user data object as returned from the server
       *
       * @typedef {Object} FileUploadRequest - an object containing the result of the file upload request
       * @property {FileInfo} FileUploadRequest.fileInfo - file information on the uploaded file
       * @property {string} FileUploadRequest.location - a file service URI where the uploaded file can be found
       *
       * @see atex.aceui.service.FileService
       * @see AuthenticationService
       *
       * @returns {Promise.<FileUploadRequest, atex.aceui.error.Error>}
       */
      uploadTemporaryFile: function(transferInfo) {
        return AuthenticationService.callWithAuthentication(function(currentUser) {
          return AuthenticationService.verifyLoggedIn().then(function() {
            return handler().then(function(serviceHandler) {
              return serviceHandler.uploadTemporaryFile(_.extend(transferInfo, { authToken: currentUser.token }));
            });
          });
        });
      }
    };
  }
]);
